import { render, staticRenderFns } from "./ChartTable.vue?vue&type=template&id=b5b473de&scoped=true"
import script from "./ChartTable.vue?vue&type=script&lang=js"
export * from "./ChartTable.vue?vue&type=script&lang=js"
import style0 from "./ChartTable.vue?vue&type=style&index=0&id=b5b473de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5b473de",
  null
  
)

export default component.exports